import cookie from '@/services/cookie'
import sib from '@/services/sib'
import zoho from '@/services/zoho'
import mixpanelUtils from '@/utils/mixpanel.utils'

import UserApi from '@/api/user'
import ABTestApi from '@/api/abTest'
import AccountApi from '@/api/account'
import utils from '@/util'

import constants from '@/constant'

import sentry from '@/services/sentry'

const { eventCategories, AB_TEST } = constants

const AB_TEST_CODE = {
  FRENCH: 'LOCALIZATION_FRENCH',
}
const USER_COUNTRY = {
  FRENCH: 'France',
}
const FRENCH_AB_TEST_GROUP = {
  CONTROL: 'CONTROL',
  TREATMENT: 'TREATMENT',
}
const setCurrentUserAction = async ({ commit }, payload) => {
  commit('setCurrentUser', payload)
}

const setPlan = async ({ commit }, payload) => {
  commit('setPlan', payload)
}

const updateCurrentABTestAction = async ({ commit }, payload) => {
  commit('updateCurrentABTest', payload)
}

const callApiGetABTest = async (abTestCode) => {
  try {
    return ABTestApi.getTest(abTestCode)
  } catch (e) {
    sentry.captureException(e)
    return false
  }
}

const handleFrenchLanguageABtest = async ({ commit }, currentUser) => {
  if (currentUser && currentUser.personalInformation &&
    currentUser.personalInformation.presenterLanguage &&
    currentUser.personalInformation.presenterLanguage !== 'fr') return
  if (currentUser.country !== USER_COUNTRY.FRENCH) {
    return
  }
  const userAlreadyBelongToThisExperiment = currentUser.abTest && currentUser.abTest[AB_TEST_CODE.FRENCH]
  if (userAlreadyBelongToThisExperiment) {
    return
  }

  const resGetAbTest = await callApiGetABTest(AB_TEST_CODE.FRENCH)
  if (!resGetAbTest || !resGetAbTest.body) {
    return
  }

  const { testCode, variant } = resGetAbTest.body
  const hasABTestData = testCode && variant
  if (!hasABTestData) {
    return
  }

  const newExperiment = {
    [AB_TEST_CODE.FRENCH]: variant,
  }
  commit('updateCurrentUser', newExperiment)
}

const updateLocalStorageAndUserAndSettings = async (currentUser) => {
  if (!window.localStorage.getItem(`localizeI18n-${currentUser.id}`)) {
    window.localStorage.setItem(`localizeI18n-${currentUser.id}`, constants.presenterLanguage.fr)
  }
  const updatePresenterLanguageCondition = (
    currentUser &&
    (!currentUser.personalInformation ||
      (currentUser.personalInformation && !currentUser.personalInformation.presenterLanguage))
  )
  if (updatePresenterLanguageCondition) {
    await UserApi.patchUserById(currentUser.id, {
      personalInformation: {
        presenterLanguage: constants.presenterLanguage.fr,
      },
      rememberSettings: {
        language: constants.presenterLanguage.fr,
      },
    })
    currentUser.rememberSettings.language = constants.presenterLanguage.fr
    if (!currentUser.personalInformation) currentUser.personalInformation = {}
    currentUser.personalInformation.presenterLanguage = constants.presenterLanguage.fr
  }
  return currentUser
}
const getCurrentUserAction = async ({ commit, state, dispatch }) => {
  let { currentUser } = state

  try {
    // phải lấy profile 2 lần nếu k thì k thì có bug khi signup từ form ở trang chủ
    // http://localhost:8080/pages/token?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzU
    // sImlhdCI6MTYzMjIxODAyNiwiZXhwIjoxNjk1MjkwMDI2fQ.dOpl8ICE7i-2624J5pmVQJdO4mcBpUgJkE
    // 7UkvZAlOI&signup=1&name=loi&email=stove+102test@gmail.com
    if (!currentUser.id) {
      currentUser = await UserApi.getUser()
    }
  } catch (error) {
    commit('setIsServerConnectable', false)

    utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'User > Load > Failed')
    throw error
  }

  currentUser.rememberSettings = currentUser.rememberSettings || {}
  if (currentUser.accountId) {
    dispatch('getCurrentTeamAction', currentUser.accountId)
  }
  if (currentUser.id && currentUser.plan !== 'white-label') {
    currentUser.isPlayingDemoEnabled = false
    if (!currentUser.playedPresentationIds ||
      (currentUser.playedPresentationIds && !currentUser.playedPresentationIds.length)) {
      currentUser.isPlayingDemoEnabled = true
    }
  }

  commit('setCurrentUser', currentUser)
  commit('setPlan', currentUser.plan)
  await handleFrenchLanguageABtest({ commit }, currentUser)

  const isPresenterLanguageWasFrench = (
    !currentUser.personalInformation ||
    (
      currentUser.personalInformation &&
        (
          !currentUser.personalInformation.presenterLanguage ||
          currentUser.personalInformation.presenterLanguage === constants.presenterLanguage.fr
        )
    )
  )
  const isTreatmentFrenchLocalizeState = (currentUser.abTest
    && currentUser.abTest[AB_TEST_CODE.FRENCH] === FRENCH_AB_TEST_GROUP.TREATMENT)
  const isTreatmentFrenchLocalizeLocalstorage = window.localStorage.getItem(`localizeI18n-${currentUser.id}`) === constants.presenterLanguage.fr
  if ((isTreatmentFrenchLocalizeState || isTreatmentFrenchLocalizeLocalstorage) && isPresenterLanguageWasFrench) {
    dispatch('setCurrentUserI18nLang', constants.presenterLanguage.fr)
    currentUser = await updateLocalStorageAndUserAndSettings(currentUser)
  }
  // store user id into for logging purpose
  cookie.setValue('aha-user-id', currentUser.id)
  cookie.setValueByDomain('aha-user-id', currentUser.id)

  try {
    // a/b test merge pickAnswer & pickImage
    if (currentUser.id && currentUser.id % 4 === 3) {
      constants.allTypeSections.forEach((item) => {
        if (item.slideTypes) {
          item.slideTypes.forEach((obj) => {
            if (obj.type === 'pickAnswer' && obj.slideType === 'imageChoice') {
              obj.name = 'Pick Answer'
              obj.desc = 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.'
              obj.ahaIcon = 'pick-answer'
              obj.ahaIconWhite = 'pick-answer-w'
            }
          })
        }
      })
    }
  } catch {
    // do nothing
  }

  sentry.identifyUser(currentUser)
  sib.identifyUser(currentUser)
  zoho.identifyUser(currentUser)

  // TODO: should simplify with one funcion call like above
  mixpanelUtils.identify(currentUser)

  // mixpanelUtils.track('Access presenter app')

  return currentUser
}

const getCurrentTeamAction = async ({ commit }, teamId) => {
  try {
    const currentAccount = await AccountApi.getAccountById(teamId)
    if (!currentAccount.id) currentAccount.id = 0
    commit('setCurrentAccount', currentAccount)
  } catch (error) {
    if (error.status === 403) {
      commit('setCurrentAccount', {})
    }
  }
}

const setCurrentUserI18nLang = async ({ commit }, country) => {
  commit('setPresenterLang', country)
}
const setCurrentUserHasCreatedPresentationAction = async ({ commit, state }) => {
  const userHasCreatedPresentation = state.currentUser.personalInformation &&
        state.currentUser.personalInformation.hasCreatedPresentation

  if (!userHasCreatedPresentation) {
    const res = await UserApi.patchUserById(state.currentUser.id, {
      personalInformation: {
        ...state.currentUser.personalInformation,
        hasCreatedPresentation: true,
      },
    })

    const patchedUser = {
      ...state.currentUser,
      ...res.body,
    }

    commit('setHasOnboardingV3', false)
    commit('setCurrentUser', patchedUser)
  }
}

const updateCurrentUserAction = async ({ commit }, payload) => {
  commit('updateCurrentUser', payload)
}

const setUpAbTestShareV2Action = async ({ commit }) => {
  const resGetAbTest = await callApiGetABTest(AB_TEST.SHARE_V2)
  if (!resGetAbTest || !resGetAbTest.body) {
    return false
  }

  const { testCode, variant } = resGetAbTest.body
  const hasABTestData = testCode && variant
  if (!hasABTestData) {
    return false
  }

  const payload = {}
  payload[AB_TEST.SHARE_V2] = variant
  commit('updateCurrentABTest', payload)
  return payload
}

export default {
  getCurrentUserAction,
  setCurrentUserAction,
  setPlan,
  setCurrentUserHasCreatedPresentationAction,
  updateCurrentUserAction,
  updateCurrentABTestAction,
  getCurrentTeamAction,
  setCurrentUserI18nLang,
  setUpAbTestShareV2Action,
}
